import React, { useState } from "react";
import TopNavbar from "../../shares/TopNavbar";
import { PublicComplianceFooter } from "../../shares/PublicSiteChrome";
import * as auth from "../../services/auth";
import qboConnectButton from "../../images/Connect_to_QuickBooks_buttons/Connect_to_QuickBooks_English/Connect_to_QuickBooks_SVG/C2QB_green_btn_med_default.svg";

export default function Connect() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const startOAuth = () => {
        if (loading) return;
        setLoading(true);
        setError("");
        auth.connectQuickBooks()
            .then((response) => {
                window.location.href = response.url;
            })
            .catch((err) => {
                console.log(err);
                setError("Could not start QuickBooks Online authorization. Please try again.");
                setLoading(false);
            });
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <TopNavbar />
            <main className="container mx-auto px-4 py-10">
                <div className="mx-auto max-w-2xl bg-white shadow-lg rounded-lg p-8">
                    <h1 className="text-3xl font-bold tracking-tight text-gray-900">Connect to QuickBooks Online</h1>
                    <p className="mt-3 text-gray-700">
                        Start the QuickBooks Online OAuth flow. You will be redirected to Intuit to authorize access and
                        then returned to this application.
                    </p>
                    <p className="mt-2 text-sm text-gray-500">
                        Intuit and QuickBooks are registered trademarks of Intuit Inc. Used with permission.
                    </p>

                    {error ? (
                        <div className="mt-4 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div>
                    ) : null}

                    <div className="mt-6">
                        <button
                            type="button"
                            onClick={startOAuth}
                            disabled={loading}
                            className="disabled:opacity-60"
                            title="Authorize QuickBooks Online"
                            aria-label="Connect to QuickBooks Online"
                        >
                            <img src={qboConnectButton} alt="Connect to QuickBooks Online" className="h-9 w-auto" />
                        </button>
                    </div>
                </div>

                <div className="mx-auto mt-8 max-w-4xl">
                    <PublicComplianceFooter />
                </div>
            </main>
        </div>
    );
}
